/**
 * Identidad del afiliado: su CUIL. En auth el email es sintetico
 * `<cuil>@afiliados.atsa.interno` (dominio distinto al de empresas para que una
 * persona pueda ser a la vez usuario de empresa y afiliado). ADR #048.
 */
export const AFILIADO_EMAIL_DOMAIN = 'afiliados.atsa.interno';

export function cuilDigits(value: string | null | undefined): string {
  return (value ?? '').replace(/[^0-9]/g, '');
}

/** Valida CUIT/CUIL con el digito verificador de AFIP (modulo 11). */
export function validarCuil(value: string): boolean {
  const clean = cuilDigits(value);
  if (clean.length !== 11) return false;
  const multipliers = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(clean[i], 10) * multipliers[i];
  const mod = sum % 11;
  const dv = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
  return dv === parseInt(clean[10], 10);
}

/** Formato XX-XXXXXXXX-X mientras se escribe (acepta entradas parciales). */
export function formatCuil(value: string | null | undefined): string {
  const d = cuilDigits(value).slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}

export function cuilToEmail(cuil: string): string {
  return `${cuilDigits(cuil)}@${AFILIADO_EMAIL_DOMAIN}`;
}
